import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledIdentationDivider = styled.div(
    ({theme: {palette}}) => css`
        position: absolute;
        left: 0;
        height: 100%;
        width: 5px;
        background-color: ${palette.neutral['100']};
        top: 0%;
    `
)

export const StyledIndentedGridItem = styled(GridItem)<{$isFirstRow: boolean}>(
    ({theme: {spacing}, $isFirstRow}) => css`
        position: relative;
        padding-left: ${$isFirstRow ? 0 : `${spacing * 4}px`};
    `
)
